export const compressVideo = async (file) => {
  // ✅ For now, skip compression and allow all videos
  return file;
};
